// auth.slice.ts
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { getStorageAllPlatforms, removeStorageAllPlatforms, setStorageAllPlatforms } from '@/utils/LocalStorageForAllPlatforms';

type AuthState = {
  token: string | null;
};

const initialState: AuthState = {
  token: null, // starts as null, gets updated by thunk
};

// Async thunk to load token from storage
export const loadToken = createAsyncThunk(
  'auth/loadToken',
  async () => {
    const token = await getStorageAllPlatforms('token');
    return token ?? null;
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
      setStorageAllPlatforms('token', action.payload);
    },
    clearToken: (state) => {
      state.token = null;
      removeStorageAllPlatforms('token');
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadToken.fulfilled, (state, action) => {
      state.token = action.payload;
    });
  },
});

export const { setToken, clearToken } = authSlice.actions;
export default authSlice.reducer;
